export const filterTypes = {
  SINGLE_SELECT: 'single-select',
  MULTI_SELECT: 'multi-select',
  RANGE: 'range-filter',
  CATEGORY: 'category-filter',
  COLOR: 'color-filter',
};

export const toolTipMetadata = {
  Gender: {
    tooltipText: 'Click here to filter by Gender',
  },
};
